import React from "react";
import "./Data_Loader.css";
import Data_Loader_lottie from "../Data_Loader_lottie/Data_Loader_lottie";


function Data_Loader() {
  return (
    <div className="Data_Loader">
      <Data_Loader_lottie/>
    </div>
  );
}

export default Data_Loader;